import {Controller} from '@stubhub/react-store-provider';

import {
  currentLocaleSelector,
  defaultCurrencySelector,
  defaultLocaleSelector,
  isAdvisoryEnabledSelector,
  isLanguageSelectorEnabledSelector,
  shstoreIdSelector,
  supportedLocalesSelector,
} from './selectors';

const NAMESPACE = 'headerNav';

const selectedCurrencySelector = ({currencyExchange = {}}) => currencyExchange.selectedCurrency;

const controller = new Controller({
  namespace: NAMESPACE,
  actionCreators: {
    setActiveMenuKey,
  },
  reducers: ['SET_ACTIVE_MENU_KEY'],
  mapStateToProps(state) {
    const {device} = state;

    return {
      shstoreId: shstoreIdSelector(state),
      deviceType: device && device.type,
      selectedCurrencyCode: selectedCurrencySelector(state),
      defaultLocale: defaultLocaleSelector(state) || 'en-GB',
      currentLocale: currentLocaleSelector(state),
      supportedLocales: supportedLocalesSelector(state),
      defaultCurrency: defaultCurrencySelector(state),
      isAdvisoryEnabled: isAdvisoryEnabledSelector(state),
      isLanguageSelectorEnabled: isLanguageSelectorEnabledSelector(state),
    };
  },
});

function setActiveMenuKey(key) {
  return (dispatch) =>
    dispatch({
      type: 'SET_ACTIVE_MENU_KEY',
      activeMenuKey: key,
    });
}

export default controller;
